import { useEffect } from "react";

import * as Sentry from "@sentry/react";

import { DIALOG_NAME, WEBSOCKET_EVENT } from "src/constants";
import { useWebSocketContext } from "src/contexts/WebSocketContext";
import useGlobalDialog from "src/redux/hooks/useGlobalDialog";

const WebhookEventHandler = () => {
  const { lastMessage } = useWebSocketContext();
  const { setData: setCurrentDialog } = useGlobalDialog();

  useEffect(() => {
    const message = lastMessage?.data;
    if (message) {
      let data;
      try {
        data = JSON.parse(message);
      }
      catch (err) {
        Sentry.captureException(err, {
          tags  : { component: "WebhookEventHandler" },
          extra : { messageLength: String(message).length },
          level : "error",
        });
        return;
      }
      if (data.event === WEBSOCKET_EVENT.RESET_KYC) {
        setCurrentDialog(DIALOG_NAME.KYC_RESET);
      }
      else if (data.event === WEBSOCKET_EVENT.RESET_COUNTRY) {
        setCurrentDialog(DIALOG_NAME.COUNTRY_RESET);
      }
      else if (data.event === WEBSOCKET_EVENT.ACCOUNT_BLOCKED) {
        setCurrentDialog(DIALOG_NAME.ACCOUNT_BLOCKED);
      }
      else if (data.event === WEBSOCKET_EVENT.ACCOUNT_UNBLOCKED) {
        setCurrentDialog(DIALOG_NAME.ACCOUNT_UNBLOCKED);
      }
    }
  }, [lastMessage, setCurrentDialog]);

  return null;
};

export default WebhookEventHandler;
